import { useContext } from 'react';
import { GlobalDataContext, TemplateContext, evaluateTemplateValue } from '@ea-lab/reactive-json';

/**
 * InitialsAvatar — rond d'initiales générique (recette `.avatar` du DS). Élément
 * reactive-json READ-ONLY : rend UNIQUEMENT la pastille (composable avec un
 * `<a>` / label en YAML, ex. colonne « Nom » de la liste des contacts). Le
 * calcul d'initiales n'est pas exprimable en YAML pur, d'où ce mini-plugin ;
 * il généralise l'ancien `TaskAssigneeAvatar` (spécifique aux tâches).
 *
 * props: { name, size } — size ∈ { xs, sm, md (défaut), lg }.
 */

/**
 * Deux premières initiales d'un nom, en majuscules. Découpe sur espace, point,
 * underscore, tiret et « @ » (gère « Jean Dupont » → « JD », une adresse e-mail
 * « rosalyn.vasquez@… » → « RV », un mononyme → sa 1re lettre). « ? » si vide.
 */
export function initials(name = '') {
  const parts = String(name).split(/[.\s_@-]+/).filter(Boolean);
  const pick = (p) => {
    const m = String(p).match(/[a-z0-9]/i);
    return m ? m[0] : p[0];
  };
  const ini = parts.slice(0, 2).map(pick).join('') || String(name).charAt(0) || '?';
  return ini.toUpperCase();
}

const ev = (gdc, tc) => (v) => {
  try {
    return evaluateTemplateValue({ valueToEvaluate: v, globalDataContext: gdc, templateContext: tc });
  } catch {
    return undefined;
  }
};

export function InitialsAvatar({ props = {} }) {
  const e = ev(useContext(GlobalDataContext), useContext(TemplateContext));
  const name = e(props.name);
  const size = e(props.size);
  const cls = size && size !== 'md' ? `avatar avatar-${size}` : 'avatar';
  return (
    <span className={cls} aria-hidden="true">{name ? initials(name) : '?'}</span>
  );
}
